export default {
  namespaced: true,
  state: {
    settings: null,
    mainAccount: null,
    googleReviewUrl: null,
    gmbAccounts: [],
    gmbLocations: [],
    invitationFields: [
      { id: 'status', field_name: 'status', enable: true, type: 'system' },
      { id: 'created', field_name: 'created', enable: true, type: 'system' },
    ],
    feedbackFormFields: [
      { id: 'handle', field_name: '', enable: true, type: 'system' },
      { id: 'name', field_name: 'question', enable: true, type: 'system' },
      { id: 'type', field_name: 'type', enable: true, type: 'system' },
      { id: 'required', field_name: 'required', enable: true, type: 'system' },
      { id: 'enabled', field_name: 'status', enable: true, type: 'system' },
    ],
  },
  mutations: {
    setSettings(state, data) {
      state.settings = data
    },
    setMainAccount(state, data) {
      state.mainAccount = data
    },
    setGmbAccounts(state, data) {
      state.gmbAccounts = data
    },
    setGmbLocations(state, data) {
      state.gmbLocations = data
    },
    setGoogleReviewUrl(state, data) {
      state.googleReviewUrl = data
    },
  },
  getters: {
    getSettings(state) {
      return state.settings
    },
    getMainAccount(state) {
      return state.mainAccount
    },
    hasFinishedSetup(state) {
      if (state.mainAccount?.account_id && state.mainAccount?.account_name && state.mainAccount?.location_id && state.mainAccount.location_name && state.googleReviewUrl) {
        return true
      }
      return false
    },
    getGmbAccounts(state) {
      return state.gmbAccounts
    },
    getGmbLocations(state) {
      return state.gmbLocations
    },
    getGoogleReviewUrl(state) {
      return state.googleReviewUrl
    },
    getInvitationFields(state) {
      const fields = state.invitationFields
      const savedFields = JSON.parse(localStorage.getItem('yz_review_invitation_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getFeedbackFormFields(state) {
      return state.feedbackFormFields
    }
  },
}
